// @ts-strict-ignore

import * as React from "react";
import { Link as NextLink } from "i18n/routing";
import { withTheme } from "styled-components";

import Image from "next/image";

type Props = {
  id?: string;
  src?: string;
  theme: any;
  whiteText?: boolean;
  onMouseOver?: () => void;
};

const Logo = ({ src, theme, whiteText = false, onMouseOver }: Props) => {
  const white = theme.isDark || whiteText;

  const logoSrc = white
    ? "/static/images/gemini-hor-light-full-rgb@3x.png"
    : "/static/images/gemini-hor-dark-full-rgb@3x.png";

  return (
    <NextLink href="/">
      <div onMouseOver={onMouseOver}>
        <Image
          priority
          src={src || logoSrc}
          alt="Gemini"
          width={107.81}
          height={23}
          style={{ cursor: "pointer" }}
        />
      </div>
    </NextLink>
  );
};

export default withTheme(React.memo(Logo));
